import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet';
import HeaderMobile from 'Components/HeaderMobile';
import Footer from 'Components/Footer';
import {
  acceptKVKKagreement,
  setCampaignKVKKState,
  closeModal
} from 'Store/actions';
import { isEmbeddedAppShell, getWebviewModeFlag } from 'Utils/webviewMode';
import Modal from 'Components/Modal';
import KVKKModal from 'Components/Modal/KVKKModal';
import PostponedModal from 'Components/Modal/Postponed';
import {
  PRIVACY_POLICY
} from 'Store/constants/sportTypes';
import StickyNavigation from 'Components/StickyNavigation';
import SmartAppBanner from 'Components/SmartAppBanner';
import NoSSR from 'Components/NoSSR';
import EnvironmentManager from 'Utils/environmentManager';

class ApplicationLayout extends Component {
  static propTypes = {
    children: PropTypes.node,
    helmet: PropTypes.object,
    modalData: PropTypes.object,
    headerType: PropTypes.string,
    footerType: PropTypes.string,
    navigationType: PropTypes.string,
    betSlip: PropTypes.bool,
    bottomNav: PropTypes.bool,
    loadGameListFull: PropTypes.bool,
    getSportsBooFull: PropTypes.func,
    closeModal: PropTypes.func,
    location: PropTypes.object,
    userAgent: PropTypes.object,
    acceptKVKKagreement: PropTypes.func,
    setCampaignKVKKState: PropTypes.func,
    hideStickyNavigation: PropTypes.bool,
    showVaixSearch: PropTypes.bool,
    hideSmartBanner: PropTypes.bool
  };

  constructor (props) {
    super(props);

    this.state = {
      isWebView: false,
      variant: '1'
    };
  }

  componentDidMount () {
    this.setState({
      isWebView: isEmbeddedAppShell() || getWebviewModeFlag()
    });
  }

  render () {
    const {
      children,
      helmet,
      headerType,
      footerType = 'none',
      navigationType,
      location,
      userAgent,
      modalData,
      acceptKVKKagreement,
      setCampaignKVKKState,
      hideStickyNavigation,
      showVaixSearch,
      hideSmartBanner,
      userAgent: { os, device }
    } = this.props;

    const renderKVKKModal = () => {
      if (modalData.modalNames.includes('KVKKModal')) {
        const fromCampaign = this.props.location.pathname.includes('kampanyalar');

        return (
          <Modal
            title = 'KVKK Aydınlatma Metni'
            iconName='svgWarning'
            type='waiting'
            onClose={ () => fromCampaign ? setCampaignKVKKState(false, true) : acceptKVKKagreement(PRIVACY_POLICY) }
            buttonArea={ {
              primaryButton: {
                onClick: ()=> {
                  fromCampaign ? setCampaignKVKKState(true, true) : acceptKVKKagreement(PRIVACY_POLICY);
                },
                label: 'Tamam',
              }
            } }
          >
            <KVKKModal/>
          </Modal>
        );
      }
    };

    const renderPostponedModal = () => {
      if (modalData.modalNames.includes('postponedModal')) {

        return (
          <Modal
            title="Erteleme"
            iconName="svgInfoGreen"
            className={ modalData.postponedModal?.className }
            onClose={ () => this.props.closeModal('postponedModal') }
          >
            <PostponedModal />
          </Modal>
        );
      }
    };
    const isDesktopHomePage = userAgent.device?.type === 'desktop' && location.pathname === '/';
    const { isWebView } = this.state;
    const bottomSmartBannerEnabled = EnvironmentManager.getMessageText({ key: 'bottom_smart_banner_enabled' }) === 'true';
    return (
      <>
        <Helmet { ...helmet } />

<HeaderMobile helmet={ helmet } type={ headerType } showVaixSearch={ showVaixSearch } pathname={ location.pathname } />


        { children }

        { isDesktopHomePage && hideStickyNavigation ? null
          : <NoSSR>
            { !isWebView && !hideSmartBanner && bottomSmartBannerEnabled && <SmartAppBanner /> }
            <StickyNavigation path={ location.pathname } type={ navigationType } isDesktop={ userAgent.device?.type === 'desktop' } />
          </NoSSR>
        }
        { footerType !== 'none' ? <Footer type={ footerType } platform={ os?.name } device={ device } path={ location.pathname }/> : null }

        { renderKVKKModal() }
        { renderPostponedModal() }
      </>
    );
  }
}

const mapStateToProps = state => ({
  userAgent: state.userAgent,
  modalData: state.modalData,
});

export default connect(mapStateToProps, {
  acceptKVKKagreement,
  setCampaignKVKKState,
  closeModal,
})(ApplicationLayout);

/**
 * Header Types
 * full: Full featured wide header
 * simple: Just contains logo
 * mobile-none: Not displayed in mobile, in desktop shows full version
 */
